import { HUBSPOT_TRACKING_CODE } from '@/js/components/HubSpot/Helpers/hubspot-constants.js'

export function createDynamicScriptTag(sellerBrand) {
  if (!sellerBrand) {
    return
  }

  const alreadyOnPage = document.getElementById('hs-script-loader')

  if (alreadyOnPage) {
    // console.warn('Not loading Hubspot Tracking Code (already on page)')
    return
  }

  const trackingCode = HUBSPOT_TRACKING_CODE[sellerBrand.toUpperCase()]

  if (!trackingCode) {
    return
  }

  let scriptElement = document.createElement('script')
  scriptElement.type = 'text/javascript'
  scriptElement.src = trackingCode
  scriptElement.async = true
  scriptElement.defer = true
  scriptElement.id = 'hs-script-loader'
  document.head.appendChild(scriptElement)
}
